// extracted by mini-css-extract-plugin
export default {"searchInput":"CxnNwIJ9COoly9bwXe5F"};